export default __webpack_public_path__ + "images/T2.27b6cba.png";